{
  "经营概览": "Business overview",
  "企业管理": "Enterprise management",
  "审核与反馈": "Reviews & feedback",
  "基础资料": "Reference data",
  "企业与账号": "Enterprises & accounts",
  "注册邀请码": "Registration invitations",
  "投诉与反馈": "Complaints & feedback"
}
